import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { GLOBAL } from '../global';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MensajeNovedadService {
  urlMensajeNovedad: string;
  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  };

  /**
  * @author Daniel Pareja Londoño
  * @version 2018-11-01
  * @param httpClient
  */
  constructor(
    public httpClient: HttpClient
  ) {
    this.urlMensajeNovedad = GLOBAL.URL_BASE + 'sicaMensajeNovedad';
  }

   /**
   * @author Daniel Pareja Londoño
   * @version 2018-11-01
   * @param noveId
   * Busca los mensajes de una novedad
   */
  findAllByEstadoAndSicaNovedadNoveIdOrderByFechaCreacionAsc(noveId:number):Observable<any>{
    return this.httpClient.get(this.urlMensajeNovedad+'/findAllByEstadoAndSicaNovedadNoveIdOrderByFechaCreacionAsc/'+noveId);
  }
}
